import { render, staticRenderFns } from "./TrashIcon.html?vue&type=template&id=242e6bd6&scoped=true&external"
import script from "./TrashIcon.js?vue&type=script&lang=js&external"
export * from "./TrashIcon.js?vue&type=script&lang=js&external"
import style0 from "./TrashIcon.scss?vue&type=style&index=0&id=242e6bd6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242e6bd6",
  null
  
)

export default component.exports